<template>
  <div>
    <Head title="បង្កើតកម្ចី" />
    <h1 class="moul flex items-center mb-8 text-2xl">
      <Link class="flex items-center text-indigo-400 hover:text-indigo-600" href="/loans"><CurrencyDollarIcon class="mr-2 w-8 h-8" /> កម្ចី</Link>
      <span class="text-indigo-400 font-medium"><ChevronRightIcon class="w-5 h-5" /></span> កែតម្រូវ
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap p-8">
          <div class="w-full mb-4">
            <p><span class="font-medium moul">ព័ត៌មានអតិថិជន</span></p>
            <hr>
          </div>
          <text-input disabled v-model="form.customer_id" placeholder="Type existing ID or Create New One" :error="form.errors.customer_id" class="pb-8 pr-6 w-full lg:w-1/4" label="ID អតិថិជន *" />
          <text-input disabled v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/4" label="នាមត្រកូល *" />
          <text-input disabled v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/4" label="នាមខ្លួន *" />
          <text-input disabled v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/4" label="លេខទូរសព្ទ" />
          <textarea-input disabled autocomplete="on" v-model="form.address" :error="form.errors.address" class="pb-8 pr-6 w-full lg:w-1/4" label="អាសយដ្ឋាន" />
          <div class="w-full my-4">
            <p><span class="font-medium moul">ព័ត៌មានអំពីកម្ចី</span></p>
            <hr>
          </div>
          <!-- <text-input v-model="form.city" :error="form.errors.city" class="pb-8 pr-6 w-full lg:w-1/4" label="ខេត្ត/ក្រុង" /> -->
          <select-input v-model="form.officer_id" :error="form.errors.officer_id" class="pb-8 pr-6 w-full lg:w-1/4" label="មន្ត្រី​ឥណទាន *">
            <option :value="null">ជ្រើសរើស</option>
            <option v-for="user in users" :key="user.id" :value="user.id">{{ user.first_name }} {{ user.last_name }}</option>
          </select-input>

          <text-input disabled v-model="form.loan_id" :error="form.errors.loan_id" class="pb-8 pr-6 w-full lg:w-1/4" label="ID កម្ចី *" />

          <select-input v-model="form.loan_type" :error="form.errors.loan_type" class="pb-8 pr-6 w-full lg:w-1/4" label="ប្រភេទកម្ចី *">
            <option :value="null">ជ្រើសរើស</option>
            <option value="1">បង់ថយ</option>
            <option value="2">បង់ថេរ</option>
          </select-input>

          <text-input v-model="form.amount" type="number" step="0.01" :error="form.errors.amount" class="pb-8 pr-6 w-full lg:w-1/4" label="ទឹកប្រាក់ *" />
          <select-input v-model="form.currency" :error="form.errors.currency" class="pb-8 pr-6 w-full lg:w-1/4" label="រូបបិយបណ្ណ *">
            <option :value="null">ជ្រើសរើស</option>
            <option value="រៀល">រៀល</option>
            <option value="USD">USD</option>
          </select-input>

          <text-input v-model="form.interest_rate" type="number" step="0.01" :error="form.errors.interest_rate" class="pb-8 pr-6 w-full lg:w-1/4" label="អត្រាការប្រាក់ (%) *" />
          <text-input v-model="form.term" type="number" step="1" :error="form.errors.term" class="pb-8 pr-6 w-full lg:w-1/4" label="រយៈពេល *" />
          <select-input v-model="form.term_period" :error="form.errors.term_period" class="pb-8 pr-6 w-full lg:w-1/4" label="រយៈពេលកំណត់ជា *">
            <option :value="null">ជ្រើសរើស</option>
            <option value="+1 day">ថ្ងៃ</option>
            <option value="+1 week">សប្តាហ៍</option>
            <option value="+2 weeks">កន្លះខែម្តង</option>
            <option value="+1 month">ខែ</option>
          </select-input>

          <text-input v-model="form.applied_date" :error="form.errors.applied_date" type="date" class="pb-8 pr-6 w-full lg:w-1/4" label="កាលបរិច្ឆេទអនុម័ត *" />
          <text-input v-model="form.first_payment_date" :error="form.errors.first_payment_date" type="date" class="pb-8 pr-6 w-full lg:w-1/4" label="កាលបរិច្ឆេទបង់ប្រាក់ដំបូង *" />

          <text-input v-model="form.late_payment_penalties" type="number" :error="form.errors.late_payment_penalties" class="pb-8 pr-6 w-full lg:w-1/4" label="ពិន័យ (រៀល/ថ្ងៃ បើយឺតជាង៣ថ្ងៃ)" />
          <text-input v-model="form.service_fee" type="number" step="0.01" :error="form.errors.service_fee" class="pb-8 pr-6 w-full lg:w-1/4" label="សេវាកម្មប្រ/តិ និងរដ្ឋបាល (%) *" />
          <text-input v-model="form.guarantor" :error="form.errors.guarantor" class="pb-8 pr-6 w-full lg:w-1/4" label="ឈ្មោះអ្នកធានាទី១" />
          <text-input v-model="form.guarantor_2" :error="form.errors.guarantor_2" class="pb-8 pr-6 w-full lg:w-1/4" label="ឈ្មោះអ្នកធានាទី២" />
          <textarea-input v-model="form.remarks" :error="form.errors.remarks" class="pb-8 pr-6 w-full lg:w-1/4" label="កំណត់សម្គាល់" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">បង្កើតឥឡូវនេះ</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import axios from 'axios'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'
import { CurrencyDollarIcon, ChevronRightIcon } from '@heroicons/vue/24/outline'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
    CurrencyDollarIcon,
    ChevronRightIcon,
  },
  layout: Layout,
  props: {
    users: Array,
    loan: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        customer_id: this.loan.borrower.customer_id,
        first_name: this.loan.borrower.first_name,
        last_name: this.loan.borrower.last_name,
        phone: this.loan.borrower.phone,
        address: this.loan.borrower.address,
        city: this.loan.borrower.city,
        guarantor: this.loan.guarantor,
        guarantor_2: this.loan.guarantor_2,
        borrower_id: this.loan.borrower.id,
        loan_id: this.loan.loan_id,
        loan_type: this.loan.loan_type,
        original_loan_id: this.loan.id,
        amount: this.loan.amount,
        currency: this.loan.currency,
        interest_rate: this.loan.interest_rate,
        term: this.loan.term,
        term_period: this.loan.term_period,
        applied_date: this.loan.applied_date,
        first_payment_date: this.loan.first_payment_date,
        late_payment_penalties: this.loan.late_payment_penalties,
        service_fee: this.loan.service_fee,
        remarks: this.loan.remarks,
        officer_id: this.loan.officer_id,
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/loans/update')
    },
  },
}
</script>
